import { render, staticRenderFns } from "./SignSuccess.vue?vue&type=template&id=8b2a5bb6&scoped=true&"
import script from "./SignSuccess.vue?vue&type=script&lang=js&"
export * from "./SignSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SignSuccess.vue?vue&type=style&index=0&id=8b2a5bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2a5bb6",
  null
  
)

export default component.exports